import { supabase } from '../../lib/supabaseClient';
import type { Tables, TablesUpdate } from '../../types/database.types';

export type TicketCategory = Tables<'ticket_categories'>;

export async function getAllTicketCategories(includeInactive = true): Promise<TicketCategory[]> {
  let query = supabase
    .from('ticket_categories')
    .select('*')
    .order('display_order', { ascending: true });

  if (!includeInactive) {
    query = query.eq('is_active', true);
  }

  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}

export async function createTicketCategory(input: {
  label: string;
  description?: string | null;
  pole?: string | null;
}): Promise<TicketCategory> {
  // Slug, ordre et unicité générés côté serveur (RPC admin-only).
  const { data, error } = await supabase.rpc('create_ticket_category', {
    p_label: input.label,
    ...(input.description ? { p_description: input.description } : {}),
    ...(input.pole ? { p_pole: input.pole } : {}),
  });
  if (error) throw error;
  return data as TicketCategory;
}

export async function updateTicketCategory(
  id: string,
  input: Pick<TablesUpdate<'ticket_categories'>, 'label' | 'description' | 'is_active' | 'display_order'>,
): Promise<void> {
  const { error } = await supabase.from('ticket_categories').update(input).eq('id', id);
  if (error) throw error;
}

export async function reorderTicketCategories(orderedIds: string[]): Promise<void> {
  // Update display_order for each based on its position in the array
  const updates = orderedIds.map((id, index) =>
    supabase
      .from('ticket_categories')
      .update({ display_order: index + 1 })
      .eq('id', id),
  );

  const results = await Promise.all(updates);
  const failed = results.find((r) => r.error);
  if (failed?.error) throw failed.error;
}
